type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[];
};

declare const window: WindowWithDataLayer;

export const pushToDataLayer = (event: string) => {
  window?.dataLayer?.push({
    event,
  });
};
